import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrisourceSettlementComponent } from './trisource-settlement.component';

const routes: Routes = [{ path: 'TriSourceSettlement', component: TrisourceSettlementComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrisourceSettlementRoutingModule { }
